<script setup>
    import { useChannelsStore } from '@/stores/channels'
    import InputFormHorizontal from '@/components/UI/Form/InputFormHorizontal.vue'
    import SelectContactCountryCode from '@/components/UI/Form/SelectContactCountryCode.vue'
    import FeedbackAlert from '@/components/utils/FeedbackAlert.vue'
    import AlertPrice from '@/views/dash/channels/Pages/AlertPrice.vue'

    const store = useChannelsStore()

    store.channel.type = 'telegram'
    store.channel.server_type = store.channel.server_type || 'telegram_account'

    const prevMore = store.channel.more && typeof store.channel.more === 'object'
        ? { ...store.channel.more }
        : {}
    store.channel.more = { ...prevMore }

    const savedCod = prevMore.country_cod != null && String(prevMore.country_cod).trim() !== ''
        ? String(prevMore.country_cod).replace(/\D/g, '')
        : ''
    if (!store.channel.country_cod || String(store.channel.country_cod).trim() === '') {
        store.channel.country_cod = savedCod || '55'
    }

    function getPhone(evt) {
        if (evt.cod !== undefined) {
            store.channel.country_cod = evt.cod
            store.channel.user = ''
            return
        }
        if (evt.phone !== undefined) {
            store.channel.user = evt.phone
        }
    }
</script>

<template>
    <template v-if="store.formStep === 2">
        <div class="space-y-4">
            <FeedbackAlert
                type="info"
                title="Fique atento!"
                content="Informe o número da conta Telegram que será conectada. Depois você vai escanear o QR Code no app."
            />

            <InputFormHorizontal
                v-model="store.channel.name"
                :init-value="store.channel.name"
                :block-edit="store.loading"
                label="Nome do canal"
                placeholder="Como você irá identificar o canal pelo sistema?"
                rules="required"
                vertical
            />

            <SelectContactCountryCode
                position-label="top"
                label="Número do Telegram"
                :value-phone="store.channel.user"
                :country-cod="store.channel.country_cod"
                :block-edit="store.loading"
                class="px-0"
                @phone-value="getPhone"
            />

            <AlertPrice />
        </div>
    </template>

    <div
        v-else-if="store.formStep === 1"
        class="flex-1 relative overflow-y-scroll fade_start_end pt-5"
    >
        <div class="h-96 dark:text-gray-300 space-y-3 text-sm">
            <p>
                Com o Telegram Conta você conecta um número Telegram ao Chatmix via QR Code,
                no mesmo estilo do WhatsApp Web, para atender pelos contatos dessa conta.
            </p>
            <p>
                Isso é diferente do Telegram Bot (BotFather): aqui não usa token de bot, e sim a sessão da conta.
            </p>
            <FeedbackAlert
                type="info"
                title="Próximo passo"
                content="Após salvar o canal, você será direcionado para ler o QR Code e finalizar a conexão."
            />
        </div>
    </div>
</template>
